import googleProtobufStructPb from "google-protobuf/google/protobuf/struct_pb.js"

import { frontendProxy } from "../../configs"
// import { SalesforceClient } from "../proto/salesforce_grpc_web_pb"
import { IntegratedAppsClient } from "../proto/integratedapp_grpc_web_pb"
import { NotifyRequest } from "../proto/integratedapp_pb"

export default class SalesforceAPI {
  /**
   * init the Salesforce api
   *
   * @param {string} jwt - jwt
   */
  constructor(jwt) {
    if (jwt) {
      this.client = new IntegratedAppsClient(frontendProxy)

      this.jwt = jwt
      this.baseMetadata = {
        authorization: `Bearer ${jwt}`,
        "x-proxy-cluster": "salesforce"
      }
    } else {
      throw new Error("jwt is required")
    }
  }

  /**
   * Notity salesforce api - call to
   * the generic salesforce's endpoint named "notify"
   *
   * @param {string} operationKey - the operation key on salesforce
   * @param {Object} payload - the payload object
   */
  notify(operationKey, payload) {
    // request
    const self = this

    // set notify request
    const request = new NotifyRequest()

    // set operation type
    request.setOperationKey(operationKey)

    // set payload if provided
    if (Object.keys(payload || {}).length) {
      request.setPayload(googleProtobufStructPb.Struct.fromJavaScript(payload))
    }

    // make request -> get notify response object
    return new Promise((resolve, reject) => {
      self.client.notify(request, this.baseMetadata, (err, res) => {
        console.log("err:", err)
        console.log("res:", res)
        err ? reject(err) : resolve(res.getPayload().toJavaScript())
      })
    })
  }
}
